module.exports = __webpack_public_path__ + "static/media/overview2_1.8cb148c7.png";